var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { ConfigCatProvider } from 'configcat-react';
import './index.scss';
import CalendarView from './CalendarView';
import { CalendarStateProvider } from 'context/CalendarContext';
var key = (_a = process.env.REACT_APP_CONFIGCAT_SDK_KEY) !== null && _a !== void 0 ? _a : '';
export var Calendar = function () {
    useEffect(function () {
        var shouldRefresh = localStorage.getItem('refreshed');
        if (!shouldRefresh) {
            localStorage.setItem('refreshed', 'true');
            window.location.reload();
        }
    }, []);
    return (_jsx(ConfigCatProvider, __assign({ sdkKey: key }, { children: _jsx(CalendarStateProvider, { children: _jsx(CalendarView, {}) }) })));
};
